import Arabic from './arabic.json';
import Chinese from './chinese.json';
import Czech from './czech.json';
import Danish from './danish.json';
import Esperanto from './esperanto.json';
import English from './english.json';
import Finnish from './finnish.json';
import German from './german.json';
import Hindi from './hindi.json';
import Hungarian from './hungarian.json';
import Korean from './korean.json';
import Norwegian from './Norwegian.json';
import Persian from './persian.json';
import Polish from './polish.json';
import Portuguese from './portuguese.json';
import Russian from './russian.json';
import French from './french.json';
import Italian from './italian.json';
import Japanese from './japanese.json';
import Turkish from './turkish.json';
import Swedish from './swedish.json';
import Thai from './thai.json';
export default {
  arabic: Arabic.words,
  chinese: Chinese.words,
  czech: Czech.words,
  danish: Danish.words,
  english: English.words,
  esperanto: Esperanto.words,
  finnish: Finnish.words,
  french: French.words,
  german: German.words,
  hindi: Hindi.words,
  hungarian: Hungarian.words,
  italian: Italian.words,
  japanese: Japanese.words,
  korean: Korean.words,
  norwegian: Norwegian.words,
  persian: Persian.words,
  polish: Polish.words,
  portuguese: Portuguese.words,
  russian: Russian.words,
  turkish: Turkish.words,
  swedish: Swedish.words,
  thai: Thai.words,
};
